/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteBundlesOverview } from '../../models/delivery-note-bundles-overview';
import { KeyType } from '../../models/key-type';

export interface GetBundles$Params {
  organizationSiteKey: KeyType;
}

export function getBundles(http: HttpClient, rootUrl: string, params: GetBundles$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteBundlesOverview>> {
  const rb = new RequestBuilder(rootUrl, getBundles.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteBundlesOverview>;
    })
  );
}

getBundles.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles';
